import { useState, useEffect, useContext } from 'react';
import { Table, Tooltip, Tag, Button, Row, Col, Space, Input, Empty, Modal, Upload, Menu, Dropdown, Spin, message} from 'antd';
import moment from "moment";
import { API, Storage } from 'aws-amplify';
import { UserContext } from '../../GestorContext';
import ResponsiveVisibility from '../common/ResponsiveVisibility';
import { v4 as uuidv4 } from 'uuid';

const { Search } = Input;

const Business = () => {

    const [loading, setLoading] = useState(false)
    const [data, setData] = useState([])
    const [isModalOpen, setIsModalOpen] = useState()
    const [file, setFile] = useState(null); 
    const [nameData, setNameData] = useState()
    const [itemsMenu, setItemsMenu] = useState();
    const [idBaseExterna, setIdBaseExterna] = useState();
    const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
    const [loadingAddExternalBase, setLoadingAddExternalBase] = useState(false)
  
    let userContext = useContext(UserContext);

    const createLog = async (values) => {
      await API.graphql({
        query: `mutation CreateMetrics($input: CreateMetricsInput!) {
                  createMetrics(input: $input) {
                      id
                  }
              }`,
        variables: {
          input: values
        },
      });
    };
  
    const deleteBaseExterna = async (input) => {
      try {
        await API.graphql({
          query: `
            mutation MyQuery($input: DeleteCLMInput!) {
              deleteCLM(input: $input) {
                id
              }
            }`,
          variables: {
            input: input,
          },
        })
        setIsModalOpenDelete(false)
      } catch (err) {
        //console.log("Error actualizando", err);
      }
    }

    const onClickMenuAcciones = (record) => (e) => {
      switch (e.key) {
        case "1":
          setIsModalOpenDelete(true);
          setIdBaseExterna(record.id);
          break;
        default:
      }
    };

    const menu = (record) => {
      const menuItems = [];
      if (record.cLMUserId === userContext.attributes.sub) {
        menuItems.push({
          key: "1",
          label: "Eliminar",
        });
      }
      return (
        <Menu onClick={onClickMenuAcciones(record)}>
          {menuItems.map(item => (
            <Menu.Item key={item.key}>{item.label}</Menu.Item>
          ))}
        </Menu>
      );
    };

    const columns = [
      {
        title: () => <div style={{ textAlign: 'center' }}>Nombre</div>,
        dataIndex: 'name',
        onCell: () => ({ style: { textAlign: 'center' } }),
        ellipsis: { showTitle: false },
        width: '300px',
        render: (name) => (
          <Tooltip placement="topLeft" title={name}>
            {name}
          </Tooltip>
        )
      },
      {
        title: () => <div style={{ textAlign: 'center' }}>Estado</div>,
        dataIndex: 'estatus',
        onCell: () => ({ style: { textAlign: 'center' } }),
        render: (_, { status }) => {
          let color
          let statusDescription
          switch (status) {
            case 'FAILED':
              color = 'var(--support-error)'
              statusDescription = 'Error'
              break
            case 'FINISHED':
              color = 'var(--support-correct)'
              statusDescription = 'Listo'
              break
            case 'STARTED' || 'RUNNING':
              color = 'var(--support-pend)'
              statusDescription = 'En proceso'
              break
            case 'PENDING':
              color = 'var(--support-correct)'
              statusDescription = 'Cargada'
              break
            default:
              color = 'var(--support-pend)'
              statusDescription = 'No disponibe'
          }
          return (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              width: '100%' 
            }}>
              <Tag className='tagExports'  style={{whiteSpace: 'nowrap', alignSelf: 'center'  }} color={color}>
                {statusDescription}
                </Tag>
            </div>
          );
  
  
        },
      },
      {
        title: () => <div style={{ textAlign: 'center' }}>Fecha de inicio</div>,
        dataIndex: 'createdAt',
        onCell: () => ({ style: { textAlign: 'center' } }),
        width: '200px',
        render: text => moment(text).format("YYYY/MM/DD")
      },
      {
        title: () => <div style={{ textAlign: 'center' }}>Cargado por</div>,
        dataIndex: 'user',
        onCell: () => ({ style: { textAlign: 'center' } }),
        width: '200px',
        render: (_, { user }) => (
          user?.username ? user.username : 'Desconocido'
        )
      },
      {
        
        title: (
          <ResponsiveVisibility maxWidth={1050}>
            Acciones
          </ResponsiveVisibility>
        ),
        dataIndex: 'actions',
        width: '100px',
        render: (_, record) => (
          <Dropdown overlay={() => menu(record)}>
            <a className="optionsButton">
              <svg
                width="3"
                height="10"
                viewBox="0 0 3 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="1.5" cy="1" r="1" fill="#181D2E" />
                <circle cx="1.5" cy="5" r="1" fill="#181D2E" />
                <circle cx="1.5" cy="9" r="1" fill="#181D2E" />
              </svg>
            </a>
          </Dropdown>
        ),
      },
    ]
  
  const getBasesExternas = async (userGroup) => {
    if (!userGroup) {
      setData([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    let allUsers = [];
    let nextToken = null;
    try {
      do {
        const response = await API.graphql({
          query: `
            query MyQuery($filter: ModelUserFilterInput, $nextToken: String) {
              listUsers(filter: $filter, nextToken: $nextToken) {
                items {
                  username
                  clms {
                    items {
                      id
                      name
                      count
                      s3Key
                      cLMUserId
                      status
                      createdAt
                      user {
                        username
                      }
                    }
                  }
                }
                nextToken
              }
            }
          `,
          variables: {
            filter: { groups: { eq: userGroup } },
            nextToken: nextToken,
          }
        });
        const users = response.data.listUsers.items;
        allUsers = allUsers.concat(users);
        nextToken = response.data.listUsers.nextToken;
      } while (nextToken);

      const allClms = allUsers.flatMap(user => user.clms.items.map(clm => ({
        ...clm,
        user: { username: user.username }
      })));
      setData(allClms);
    } catch (err) {
      message.error('Ocurrió un error al obtener las bases externas');
      setData([]);
    }
    setLoading(false);
  }

  useEffect(() => {
    const group = userContext?.attributes?.["custom:group"];

    if (!userContext || !userContext.attributes || !userContext.attributes.sub || !group) {
      setLoading(false);
      return;
    }

    setLoading(true);
    getBasesExternas(group);
  }, [userContext, isModalOpenDelete, isModalOpen]);

    const showModal = () => {
      setIsModalOpen(true)
    };
    const handleOk = () => {
      setLoadingAddExternalBase(true)
      handleUpload()
      setIsModalOpen(false);
    };
    const handleCancel = () => {
      setIsModalOpen(false);
      setIsModalOpenDelete(false);
      setNameData('');
      setFile(null);
    };

    useEffect(() => {
      setItemsMenu([
        {
          key: "1",
          label: "Eliminar",
        }
      ]);
    }, [data])
  
    const handleUpload = async () => {
      if (!nameData || nameData === '') {
        setLoadingAddExternalBase(false)
        return message.error('El archivo debe ser de tipo TXT o CSV');
      }
      
      if (!file) {
        setLoadingAddExternalBase(false)
        return message.error('Seleccione un archivo');
      }
      const { name } = file;

      const allowedExtensions = ['txt', 'csv'];
      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (!allowedExtensions.includes(fileExtension)) {
        setLoadingAddExternalBase(false)
        setNameData('');
        setFile();
        await createLog({
          action: `El usuario "${userContext.username}" intentó cargar un archivo con formato inválido (${fileExtension}).`,
          id: uuidv4(),
          user: userContext.username,
          view: "CLM para Empresas",
        });
        return message.error('El archivo debe ser de tipo TXT o CSV');
      }

      try {
        const fileContent = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = (event) => resolve(event.target.result);
          reader.onerror = (error) => reject(error);
          reader.readAsText(file);
        });

        const lines = fileContent.split('\n').map(line => line.trim()); 

        if (fileContent.trim() === '') {
          setNameData('');
          setFile();
          setLoadingAddExternalBase(false)
          await createLog({
            action: `El usuario "${userContext.username}" intentó cargar un archivo vacío.`,
            id: uuidv4(),
            user: userContext.username,
            view: "CLM para Empresas",
          });
          return message.error('El archivo que se intentó subir esta vacío');
        }

        if (lines[0] !== 'subscriberid') {
          setNameData('');
          setFile();
          setLoadingAddExternalBase(false)
          await createLog({
            action: `El usuario "${userContext.username}" intentó cargar una base de datos externa con un encabezado incorrecto.`,
            id: uuidv4(),
            user: userContext.username,
            view: "CLM para Empresas",
          });
          return message.error('Es necesario que el archivo contenga el encabezado subscriberid');
        }

        if (lines.length <= 1) {
          setNameData('');
          setFile();
          setLoadingAddExternalBase(false)
          await createLog({
            action: `El usuario "${userContext.username}" intentó cargar una base de datos externa sin líneas de datos.`,
            id: uuidv4(),
            user: userContext.username,
            view: "CLM para Empresas",
          });
          return message.error('El archivo debe contener al menos una línea teléfonica después del encabezado.');
        }

        const dataLines = lines.slice(1).filter(line => line.trim() !== '');

        const isValid = dataLines.every(line => {
          const cleanLine = line.replace(/[,\s\r\n\t]/g, '');
          return cleanLine.length === 10 && /^\d+$/.test(cleanLine); 
        });

        if (!isValid) {
          setNameData('');
          setFile();
          setLoadingAddExternalBase(false)
          await createLog({
            action: `El usuario "${userContext.username}" intentó cargar una base de datos externa con líneas inválidas.`,
            id: uuidv4(),
            user: userContext.username,
            view: "CLM para Empresas",
          });
          return message.error('El archivo contiene líneas inválidas');
        }

        const existingClm = await API.graphql({
          query: `
            query MyQuery($filter: ModelCLMFilterInput) {
              listCLMS(filter: $filter) {
                items { id }
              }
            }
          `,
          variables: { filter: { name: { eq: nameData } } },
        });

        if (existingClm?.data?.listCLMS?.items?.length > 0) {
          setLoadingAddExternalBase(false);
          return message.error('El nombre de CLM ya existe, intenta otro');
        }
    
        await Storage.put(`${name}`, file).then(response => {
          API.graphql({
            query: `
              mutation MyMutation($input: createCLMCustomInput!) {
                createCLMCustom(input: $input) 
              }`,
            variables: {
              input: {
                name: nameData,
                s3_key: `public/${name}`,
                user_id: userContext.attributes.sub,
             
              }
            }
          })
        });

        setIsModalOpen(false);
        setNameData('');
        setFile();
        setLoading(true);
        setLoadingAddExternalBase(false);

        message.loading('Se está procesando la BD externa. Esto tomará 30 segundos...', 30, () => {
          getBasesExternas(userContext?.attributes?.["custom:group"]);
        });
      } catch (error) {
        console.error("Error uploading file: ", error);
        setLoadingAddExternalBase(false);
        message.warning('Ocurrió un error al procesar el archivo.');
        setNameData('');
        setFile(null);
      }
    };
  
    const props = {
      onRemove: () => setFile(null),
      beforeUpload: (file) => {
        setFile(file);
        return false;
      },
      multiple: false,
      maxCount: 1,
      accept: '.txt,.csv'
    }
  
    return (
      <div className='ListAudiencesComponent'>
        <Modal
          clasName="ModalGA"
          title="Atención"
          open={isModalOpenDelete}
          onCancel={() => setIsModalOpenDelete(false)}
          footer={[
            <Button key="back" onClick={handleCancel}>
              Cancelar
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={() => deleteBaseExterna(({
                id: idBaseExterna,
              }))}
            >
              Eliminar
            </Button>,
          ]}
        >
          <p>¿Estás seguro que deseas eliminar Base Externa?</p>
        </Modal>
        <Spin spinning={loadingAddExternalBase}>
        <Modal
          title="Agregar base externa"
          open={isModalOpen}
          onOk={handleOk}
          onCancel={handleCancel}
          footer={[
            <Button key="cancel" onClick={handleCancel}>
              Cancelar
            </Button>,
            <Button
              key="ok"
              type="primary"
              onClick={handleOk}
              disabled={!file || !nameData}
              style={{
                backgroundColor: !file || !nameData ? '#d9d9d9' : '#1890ff',
                borderColor: !file || !nameData ? '#d9d9d9' : '#1890ff',
                color: !file || !nameData ? '#666' : '#fff', 
              }}
            >
              Aceptar
            </Button>,
          ]}
        >
            <div className="Text1">
              Nombre de base externa
              <Input
                placeholder="Nombre de base externa"
                value={nameData || ''} // Forzar cadena vacía si es undefined
                onChange={(e) => setNameData(e.target.value)}
              />
              <Upload
                {...props}
                fileList={file ? [file] : []}
              >
                <Tooltip
                  title={
                    <div style={{ textAlign: 'left' }}>
                      <p>Formato requerido:</p>
                      <ul style={{ margin: 0, paddingInlineStart: 20 }}>
                        <li>Archivos TXT o CSV</li>
                        <li>Encabezado: <strong>subscriberid</strong></li>
                        <li>Líneas con <strong>10 dígitos numéricos</strong></li>
                        <li>Las líneas no deben contener espacios</li>
                      </ul>
                    </div>
                  }
                  placement="right"
                  overlayStyle={{ width: 300 }}
                >
                  <Button>Seleccionar archivo</Button>
                </Tooltip>
              </Upload>
            </div>
          </Modal>
        </Spin>
  
        <Row className="MenuListAudience"   style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          marginBottom: '20px'
        }}>
          <Col
            className="TituloBoldGA Col1MenuExports"
          >
            Bases de datos externas
          </Col>
          <Col>
            <Button
              className="SubtituloRegularGA Button1"
              type="primary"
              onClick={() => setIsModalOpen(true)}
            >
              Nueva
            </Button>
          </Col>
        </Row>
        <Table
          className='tableDataBaseExternal'
          loading={loading}
          columns={columns}
          dataSource={data}
          pagination={false}
          rowKey='id'
          scroll={{
            //x: 1500,
            y: 300,
          }}
        />
        {!data.length && <Empty description='Sin datos' />}
  
      </div>
    );
};

export default Business
